export default "__VITE_ASSET__abK3CYF8__"